import CatalogController from "./controllers/catalog-controller";

export const showCatalogPopup = (logoData, catalogList) => {
  new CatalogController({logoData, catalogList}).show();
};
